import React from "react";

import check from '../../images/wealth.png'
import check1 from '../../images/pool.png'
import check2 from '../../images/briefcase.png'
import check3 from '../../images/active.png'
import check4 from '../../images/transparency2.png'
import check5 from '../../images/client.png'
const Strategy = () => {
  return (
    <>
       <section className="mt-5 fund_benefits_section">
        <div className="fund_benefits  py-5">
        <div className="container">
          <h2 className="heading text-center " >
            Brighter Mind Alternate Investment Fund Benefits
          </h2>
          <div className="row mt-3">
            <div className="col-12">
              <div className="row gy-4 justify-content-center">
                <div className="col-lg-2 col-md-4 col-6  fw-medium">
                 <div className="d-flex flex-column align-items-center benifit-card">
                 <div className="check-box">
                 <img src={check} alt="Check" width={36} /> 
                 </div>
                 <p className="mb-0 fw-medium">Focus on Long Term Wealth</p>
                 </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6  fw-medium">
                <div className="d-flex flex-column align-items-center benifit-card">
               <div className="check-box">
               <img src={check1} alt="Check" width={36} />
               </div>
                <p className="mb-0  fw-medium">Higher Alpha due to pooled fund</p>
                </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6  fw-medium">
                <div className="d-flex flex-column align-items-center benifit-card">
               <div className="check-box">
               <img src={check3} alt="Check" width={36} />
               </div>
                <p className="mb-0  fw-medium">Enhanced Portfolio Diversification</p>
                </div>
                 
                </div>
                <div className="col-lg-2 col-md-4 col-6  fw-medium">
                <div className="d-flex flex-column align-items-center benifit-card">
              <div className="check-box">
              <img src={check2} alt="Check" width={36} /> 
              </div>
                <p className="mb-0  fw-medium">Active Portfolio Management</p>
                </div>
                  
                </div>
                <div className="col-lg-2 col-md-4 col-6 fw-medium">
               <div className="d-flex flex-column align-items-center benifit-card">
              <div className="check-box">
              <img src={check4} alt="Check" width={36} />
              </div>
               <p className="mb-0  fw-medium">Transparency</p>
               </div>
                 
                </div>
                <div className="col-lg-2 col-md-4 col-6 fw-medium">
               <div className="d-flex flex-column align-items-center benifit-card">
              <div className="check-box">
              <img src={check5} alt="Check" width={36} />
              </div>
                <p className="mb-0  fw-medium">Client Centric Approach</p>
                 
               </div>
                </div>
              </div>
            </div> 
          </div>
        </div>
        </div>
      </section>
         <section className="my-5 container">
        <h2 className="heading text-center ">FAQ</h2>
        <div className="row gy-3 mt-3">
            <div className="col-12">
            <div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
      1.	What type of AIF is Brighter Mind’s Alternate Investment Fund?
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">Brighter Mind AIF is a long-only category III AIF, with exposure in only listed Indian equities.</div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
      2.	What is the minimum investment amount for AIF?
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">The minimum investment amount is Rs. 1 Crore for availing the Brighter Mind AIF services.</div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button  collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
      3.	What is tax computation in AIF?
      </button>
    </h2>
    <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">Your wealth created from the scheme is exempted from all the taxation. This is because all the tax computation happens at fund level.</div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
      4.	Is there any lock-in in Brighter Mind AIF?
      </button>
    </h2>
    <div id="flush-collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">Yes, there is a lock-in period of 1 year in Brighter Mind AIF. </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
      5.	How are AIFs regulated in India?
      </button>
    </h2>
    <div id="flush-collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">AIFs in India are regulated by the Securities and Exchange Board of India (SEBI) under the SEBI (Alternative Investment Funds) Regulations, 2012.</div>
    </div>
  </div>
</div>
            </div>
        </div>
        </section>
     
    </>
  );
};

export default Strategy;
